var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
import { Mutation } from 'vuex-class';
import bus from '~/store/bus';
import HelpLeft from '~/components/layouts/helper/Left';
import { saasForeign } from '~/request/api/Common.js';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showMask = false;
        _this.thisHelpName = '';
        _this.detailInfo = {};
        return _this;
    }
    default_1.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var that, a;
            return __generator(this, function (_a) {
                that = this;
                this.setCurrMenu(4);
                a = this.$route.path.split('/');
                this.detailSelect(a[a.length - 1]);
                document.body.onclick = function () {
                    var closeImg = document.getElementsByClassName('scaleImg')[0] || [];
                    closeImg.className = 'close';
                    that.hideMask();
                };
                bus.$on('startOnload', function () {
                    var articleList = document.getElementsByClassName('article')[0].children;
                    for (var _i = 0, articleList_1 = articleList; _i < articleList_1.length; _i++) {
                        var item = articleList_1[_i];
                        var _loop_1 = function (i) {
                            if (i.nodeName === 'IMG') {
                                i.title = '双击图片可放大';
                                i.ondblclick = function () {
                                    that.showMask = true;
                                    i.className = "scaleImg";
                                    bus.$emit('dragStart');
                                };
                            }
                        };
                        for (var _a = 0, _b = item.children; _a < _b.length; _a++) {
                            var i = _b[_a];
                            _loop_1(i);
                        }
                    }
                });
                bus.$on('dragStart', function () {
                    var dragImg = document.getElementsByClassName("scaleImg")[0];
                    dragImg.onmousedown = function (ev) {
                        var oevent = ev || event;
                        var distanceX = oevent.clientX - dragImg.offsetLeft;
                        var distanceY = oevent.clientY - dragImg.offsetTop;
                        document.onmousemove = function (ev) {
                            var oevent = ev || event;
                            dragImg.style.left = oevent.clientX - distanceX + 'px';
                            dragImg.style.top = oevent.clientY - distanceY + 'px';
                        };
                        document.onmouseup = function () {
                            document.onmousemove = null;
                            document.onmouseup = null;
                            this.showMask = false;
                        };
                    };
                });
                return [2];
            });
        });
    };
    default_1.prototype.hideMask = function () {
        this.showMask = false;
    };
    default_1.prototype.treeTo = function (a, b) {
        for (var i in a) {
            a[i].isBol = false;
            if (a[i].children) {
                for (var j in a[i].children) {
                    if (a[i].children[j].type_id == b) {
                        this.thisHelpName = a[i].children[j].type_name;
                        a[i].isBol = true;
                    }
                }
            }
        }
        return a;
    };
    default_1.prototype.detailSelect = function (a) {
        return __awaiter(this, void 0, void 0, function () {
            var result, a_1, a_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, saasForeign(this.$axios, { params: 'GetContentSingle' }).selects({
                            id: a
                        })];
                    case 1:
                        result = (_a.sent()).data.result;
                        this.detailInfo = result;
                        if (this.detailInfo.update_time) {
                            a_1 = this.detailInfo.update_time.split('T').join(' ');
                            this.detailInfo.update_time = a_1;
                        }
                        if (this.detailInfo.create_time) {
                            a_2 = this.detailInfo.create_time.split('T').join(' ');
                            this.detailInfo.create_time = a_2;
                        }
                        this.setHelpType(result.second_id);
                        this.$nextTick(function () {
                            bus.$emit('startOnload');
                        });
                        return [2];
                }
            });
        });
    };
    __decorate([
        Mutation('SET_CURR_MENU')
    ], default_1.prototype, "setCurrMenu", void 0);
    __decorate([
        Mutation('SET_HELP_TYPE')
    ], default_1.prototype, "setHelpType", void 0);
    default_1 = __decorate([
        Component({
            components: {
                HelpLeft: HelpLeft
            },
            layout: 'helper',
            middleware: 'auth'
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/trait/help/detail/_id.vue
// module id = 93lE
// module chunks = 6